import { Datipreventivo } from "../model/datipreventivo";
import { Lead } from "../model/lead";
import { ComparatoregasComponent } from "../comparatoregas/comparatoregas.component";

export class DatiGas {
    public static dati(): Datipreventivo {
        return {
            id_comodity: 2,
            lead: new Lead(),
            component: ComparatoregasComponent,
            datiextra: [
                
                {
                    idDato: 3,
                    tipodato: 2, //lst
                    lstopzione: [
                        
                        {
                            value :"2",
                            des:"Business",
                            urlfoto:""
                        } ,
                        {
                            value :"1",
                            des:"Residenziale",
                            urlfoto:""
                        }

                    ],
                    descrizione: "Tipo Contratto?",
                    valore: "1"
                },
                {
                    idDato: 1,
                    tipodato: 2, //string
                    lstopzione: [
                        {
                            value :"5000",
                            des:"oltre 5000",
                            urlfoto:""
                        },
                        {
                            value :"2000",
                            des:"2000",
                            urlfoto:""
                        },
                        {
                            value :"1400",
                            des:"14000",
                            urlfoto:""
                        },
                        {
                            value :"700",
                            des:"700",
                            urlfoto:""
                        },
                        {
                            value :"480",
                            des:"480",
                            urlfoto:""
                        },
                        {
                            value :"120",
                            des:"120",
                            urlfoto:""
                        }

                    ],
                    descrizione: "Consumo annuo",
                    valore: "400"
                },
                {
                    idDato: 2,
                    tipodato: 2, //string
                    lstopzione: [
                        {
                            value :"6",
                            des:" Zona MERIDIONALE",
                            urlfoto:""
                        },
                        {
                            value :"5",
                            des:" Zona CENTRO SUD OCCIDENTALE",
                            urlfoto:""
                        },
                        {
                            value :"4",
                            des:"Zona CENTRO SUD ORIENTALE ",
                            urlfoto:""
                        },
                        {
                            value :"3",
                            des:"Zona CENTRALE",
                            urlfoto:""
                        },
                        {
                            value :"2",
                            des:"Zona NORD ORIENTALE",
                            urlfoto:""
                        },
                        {
                            value :"1",
                            des:" Zona NORD OCCIDENTALE ",
                            urlfoto:""
                        }

                    ],
                    descrizione: "Zona ",
                    valore: "1"
                },
                {
                    idDato: 4,
                    tipodato: 2, //lst
                    lstopzione: [
                        
                        {
                            value :"2",
                            des:"RID",
                            urlfoto:""
                        } ,
                        {
                            value :"1",
                            des:"RBollettino",
                            urlfoto:""
                        }

                    ],
                    descrizione: "Modalità Pagamento",
                    valore: "1"
                },
            ]

        };
    }
}




// WEBPACK FOOTER //
// ./src/app/archiviodatipreventivo/dati-gas.ts